import {nanoid} from 'nanoid';

const MERCHANT = {
  ID: 'id',
  MERCHANT_NAME: 'MerchantName',
  MERCHANT_ID: 'merchantId',
  LOCATION_ID: 'locationId',
  USER_FULL_NAME: 'ownerFullName',
  USER_EMAIL: 'userEmail',
  MERCHANT_URL: 'reviewedStatus',
  SHORT_URL: 'orderType',
  S2E_URL: 'date',
  ADDRESS: 'address',
  MENU_LINK: 'menuLink',
  IMAGES_LINK: 'imagesLink',
  IT_TEAM_CONTACT: 'teamContact',
  HOST_LINK: 'hostLink',
  HOST_USERNAME: 'hostUsername',
  HOST_PASSWORD: 'hostPassword',
  WEB_CONFIG_ID: 'WixWebOrderingConfigId',
  MENU_CONFIG_ID: 'WixMenuConfigId'
};

export const SALES_PACKAGES = [
  {id: nanoid(), packageName: '$0 package', value: 0},
  {id: nanoid(), packageName: '$1 package', value: 1},
  {id: nanoid(), packageName: '$2 package', value: 2}
];

export default MERCHANT;
